<template>
  <v-container>
    <page-heading>{{ pageTitle }}</page-heading>

    <ajax-table
      ref="objectsTable"
      :resource="resourceUrl"
      :headers="[
        {text: 'object.objectId', value: 'id'},
        {text: 'object.name', value: 'name'},
        {text: 'object.status', value: 'status'},
        {text: 'object.group', value: 'group.name'},
        {text: 'object.address', value: 'address'},
        {text: 'object.owner', value: 'owner.fullName'},
        {text: '', value: 'actions'}
      ]"
      :filter="objectsFilter"
      :page-options="{sortBy: ['id'], sortDesc: [true]}"
      exportable
    >
      <template v-slot:filters>
        <v-col cols="6" sm="6" md="4" lg="3" offset-lg="9">
          <search v-model="objectsFilterData.search" width="auto" />
        </v-col>
        <v-col cols="6" sm="6" md="4" lg="3">
          <v-select
            v-model="objectsFilterData.status"
            :label="trans('object.showInactive')"
            :items="showStatus"
            hide-details
          />
        </v-col>
        <v-col cols="6" sm="6" md="4" lg="3">
          <select-group
            :group-id.sync="objectsFilterData.groupId"
            hide-details
          />
        </v-col>
        <v-col cols="6" sm="6" md="4" lg="3">
          <select-object
            :object-id.sync="objectsFilterData.objectId"
            clearable
            hide-details
          />
        </v-col>
        <v-col cols="6" sm="6" md="4" lg="3">
          <select-object-city
            :value.sync="objectsFilterData.objectCities"
            clearable
            hide-details
          />
        </v-col>
      </template>

      <template v-slot:item.name="{ item }">
        <object-name :value="item" :open-in-new-tab="false"></object-name>
      </template>

      <template v-slot:item.group.name="{ item }">
        <object-group-name :value="item.group" :open-in-new-tab="false" />
      </template>

      <template v-slot:item.address="{item}">
        <div class="subtext">{{ item.street }}</div>
        <div class="subtext">{{ item.zipcode }} {{ item.city }} {{ item.country != 'Deutschland' ? (', ' + item.country) : '' }}</div>
      </template>

      <template v-slot:item.actions="{ item }">
        <edit-button-icon @click.native="pushToRoute('ObjectPage', {objectId: item.id})" />
      </template>
    </ajax-table>
  </v-container>
</template>

<script>
import AjaxTable from '../components/AjaxTable';
import {LocaleUtils} from '../utils/locale-utils';
import PageHeading from '../components/PageHeading';
import {DateUtils} from '../utils/date-utils';
import {RouterUtils} from '../utils/router-utils';
import {MainUtils} from '../utils/main-utils';
import {comparison, eq, inList} from 'rsql-builder';
import SelectObject from '@/components/SelectObject';
import Search from '@/components/Search';
import {FilterUtils} from '@/utils/filter-utils';
import SelectObjectCity from '@/components/SelectObjectCity';
import {ObjectApi} from '../api/object-api';
import EditButtonIcon from '../components/EditIconButton';
import SelectGroup from '../components/SelectGroup';
import ObjectName from '../components/ObjectName';
import ObjectGroupName from '../components/ObjectGroupName';

export default {
  name: 'ObjectsPage',
  mixins: [
    LocaleUtils,
    DateUtils,
    RouterUtils,
    MainUtils,
    FilterUtils
  ],
  components: {
    ObjectGroupName,
    ObjectName,
    SelectGroup,
    SelectObjectCity,
    Search,
    SelectObject,
    PageHeading,
    AjaxTable,
    EditButtonIcon
  },
  props: [
    'viewMode'
  ],
  data() { return {
    objectsFilterData: {
      status: false,
      objectId: null,
      groupId: null,
      objectCities: [],
      search: null
    }
  }},

  computed: {
    showStatus () {
      return [
        {
          value: false,
          text: this.trans('general.no'),
        },
        {
          value: null,
          text: this.trans('general.yes'),
        },
        {
          value: true,
          text: this.trans('general.only'),
        }
      ]
    },
    objectsFilter () {
      let filters = [];
      if(this.objectsFilterData.status != null) {
        filters.push(comparison('status', eq(!this.objectsFilterData.status)))
      }
      if(this.objectsFilterData.objectId != null) {
        filters.push(comparison('id', eq(this.objectsFilterData.objectId)))
      }
      if(this.objectsFilterData.groupId != null) {
        filters.push(comparison('group.id', eq(this.objectsFilterData.groupId)))
      }
      if(this.objectsFilterData.objectCities != null && this.objectsFilterData.objectCities.length > 0) {
        filters.push(comparison('city', inList(...this.objectsFilterData.objectCities)))
      }
      if(this.objectsFilterData.search) {
        filters.push(this.buildSearchFilter(this.objectsFilterData.search, ['id', 'name', 'city']))
      }
      // Only new arrivals filter is set as query param
      return filters;
    },
    resourceUrl () {
      return ObjectApi.apiUri;
    },
    pageTitle () {
      return this.transPlural('object.object');
    }
  },

  mounted () {
    this.resetSearchFilters();
  },

  activated () {
    this.$refs.objectsTable.loadData();
  },

  methods: {
    resetSearchFilters () {
      this.objectsFilterData.status = false;
      this.objectsFilterData.objectId = null;
      this.objectsFilterData.groupId = null;
      this.objectsFilterData.objectCities = [];
      this.objectsFilterData.search = null;
    }
  }
}
</script>

<style>

</style>
